import { useEffect, useState } from "react";
import { Form, KeyValue } from "../interfaces";

export default function useMinLengthErrorValidation(
  form: Form,
  formMetaData: KeyValue,
  setErrors: (prevState: any) => void,
) {
  const [prevForm, setPrevForm] = useState(form);

  useEffect(() => {
    if (JSON.stringify(prevForm) !== JSON.stringify(form)) {
      setPrevForm(form);
      Object.keys(form).forEach((formKey: string) => {
        if (
          form[formKey] &&
          formMetaData[formKey] &&
          form[formKey].toString().length !== 0 &&
          form[formKey].toString().length < formMetaData[formKey].minLength
        ) {
          setErrors((prevState: Set<string>) => {
            return new Set(prevState.add(`${formKey}`));
          });
        } else {
          setErrors((prevState: Set<string>) => {
            prevState.delete(`${formKey}`);
            return new Set(prevState);
          });
        }
      });
    }
  }, [prevForm, form, formMetaData, setErrors]);
}
